import { render, staticRenderFns } from "./EditAlertModal.vue?vue&type=template&id=47a2e12c&scoped=true&"
import script from "./EditAlertModal.vue?vue&type=script&lang=js&"
export * from "./EditAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./EditAlertModal.vue?vue&type=style&index=0&id=47a2e12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a2e12c",
  null
  
)

export default component.exports